import { render, staticRenderFns } from "./appHome2.vue?vue&type=template&id=59817655"
import script from "./appHome2.vue?vue&type=script&lang=js"
export * from "./appHome2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports